import { SEND_MASS_MESSAGE } from '../../../../../constants/apiUrls/apiUrls';
import http from '../../../../../services/http';


export const sendMassMessage = (payload) => http.post(SEND_MASS_MESSAGE, payload);
